import { render, staticRenderFns } from "./ComplementariesCards.vue?vue&type=template&id=11d64db3&scoped=true&"
import script from "./ComplementariesCards.vue?vue&type=script&lang=js&"
export * from "./ComplementariesCards.vue?vue&type=script&lang=js&"
import style0 from "./ComplementariesCards.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./ComplementariesCards.vue?vue&type=style&index=1&id=11d64db3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11d64db3",
  null
  
)

export default component.exports